/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// Vision UI Dashboard PRO React base styles
import colors from "../../base/colors";
import borders from "../../base/borders";

// Vision UI Dashboard PRO React helper functions
import pxToRem from "../../functions/pxToRem";
import boxShadow from "../../functions/boxShadow";

const { white, info } = colors;
const { borderWidth } = borders;

// eslint-disable-next-line
export default {
  styleOverrides: {
    root: {
      background: info.main,
      fill: info.main,
      stroke: info.main,
      strokeWidth: pxToRem(12),
      width: pxToRem(20),
      height: pxToRem(20),
      border: `${borderWidth[3]} solid ${info.main}`,
      borderRadius: "50%",
      zIndex: 99,
      transition: "all 200ms linear",

      "&.Mui-active": {
        background: white.main,
        fill: white.main,
        stroke: white.main,
        borderColor: white.main,
        boxShadow: boxShadow([0, 0], [0, 2], white.main, 1),
      },

      "&.Mui-completed": {
        background: white.main,
        fill: white.main,
        stroke: white.main,
        borderColor: white.main,
        boxShadow: boxShadow([0, 0], [0, 2], white.main, 1),
      },
    },
  },
};
